import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  baseUrl = environment.baseUrl;
  appBaseUrl = environment.webPortaBaseUrl;
  // crmRateSearch = environment.crmRateSearchBaseUrl;
  private extractData(res: Response) {
    const body = res;
    return body || <any>{};
  }
  constructor(private http: HttpClient) { }


  CreateBooking(body): Observable<any> {
    const requestUrl = this.baseUrl + '/shipment/create';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getFilterInfo(body): Observable<any> {
    const requestUrl = this.baseUrl + '/customized_filter/' + body.module;
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getFilterInfobyId(id): Observable<any> {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/filter/get/' + id;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  updateFilterShareList(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/filter/update/' + body.id;
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }


  CreateTempLead(body): Observable<any> {
    const requestUrl = this.baseUrl + '/shipment/temp_company';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  createPartner(body): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/partner/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getDashboardWidgetList(): Observable<any> {
    const requestUrl = this.baseUrl + '/dashboard/widget';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  updateDashboardWidgets(body): Observable<any> {
    const requestUrl = this.baseUrl + '/dashboard/widget';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  resetDashboardWidgets(): Observable<any> {
    const requestUrl = this.baseUrl + '/dashboard/widget/reset';
    return this.http.put<any>(requestUrl, {}).pipe(map(this.extractData));
  }


  getContainerMonthlySummary(body?: any): Observable<any> {
    const params = new HttpParams()
      .set('filter', body && body?.filter ? body?.filter : '')
    const requestUrl = this.baseUrl + '/dashboard/monthly_container_summary/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  getPartnerList(): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/partner/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  invitePartners(body): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/partner/' + body.type;
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }


  // get shipments
  getShipment(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/shipment/get';
    // const requestUrl = this.baseUrl + '/shipment/get_list';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  // Get left side static count
  getShipmentStaticCount(body: any): Observable<any> {
    const params = new HttpParams()
      .set('type', body.type)
      .set('booking_type', !!body.booking_type ? body.booking_type : '')
    const requestUrl = this.baseUrl + '/shipment/count/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  createCustomFilter(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/filter/create';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getManageShipmentFilter(): Observable<any> {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/filter/get_manage';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  updateManageShipmentFilter(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/filter/update';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }


  getShipmentFullTimelineV2(obj: any): Observable<any> {
    const params = new HttpParams()
    // .set('booking_id', obj.booking_id)
    // .set('container_id', obj.container_id)
    const requestUrl = this.baseUrl + '/shipment/timeline/' + obj.booking_id + '/' + obj.container_id;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getShipmentBasicInfo(bookingId: any, containerId: any): Observable<any> {
    const requestUrl = this.baseUrl + '/shipment/info/' + bookingId + '/' + containerId;
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }


  // Get shipments Details specify one
  getShipmentDetails(id: any): Observable<any> {
    const requestUrl = this.baseUrl + '/shipment/info/' + id;
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  // Get getShipmentPriceInfo Details specify one
  getShipmentPriceInfo(obj: any): Observable<any> {
    const params = new HttpParams()
      .set('price_while_booking', !!obj.price_while_booking ? 1 : 0)
    const requestUrl = this.baseUrl + '/shipment/price_info/' + obj.id;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  getSearchShipments(q: any): Observable<any> {
    const params = new HttpParams()
      .set('q', q)
    const requestUrl = this.baseUrl + '/search/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getSearch(obj): Observable<any> {
    const requestUrl = this.baseUrl + '/search/' + obj.type + '/';
    return this.http.post<any>(requestUrl, obj).pipe(map(this.extractData));
  }


  getOrganisation(q: string = ''): Observable<any> {
    const params = new HttpParams()
      .set('q', q)
    const requestUrl = this.baseUrl + '/organisation/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  markShipmentHot(body): Observable<any> {
    const requestUrl = this.baseUrl + '/shipment/makehot/' + body.id + '/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  updateOrganisation(body): Observable<any> {
    const requestUrl = this.baseUrl + '/organisation/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }


  getBookingStatusCount(body: any): Observable<any> {
    const params = new HttpParams()
      .set('booking_type', body)
    const requestUrl = this.baseUrl + '/booking_status_count/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  getInvoiceList(obj: any): Observable<any> {
    const params = new HttpParams()
      .set('limit', obj.limit)
      .set('page', obj.page)
      .set('filter_type', obj.filter_type)
      .set('sort_type', obj.sort_type)
      .set('q', obj.q)
      .set('id', !!obj.id ? obj.id : '')
    const requestUrl = this.baseUrl + '/finance/invoice/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getInvoiceSummary(): Observable<any> {
    const requestUrl = this.baseUrl + '/finance/summary/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  getInvoiceStatusCount(): Observable<any> {
    const requestUrl = this.baseUrl + '/finance/status_count/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  getDashboardBookingCount(): Observable<any> {
    const requestUrl = this.baseUrl + '/dashboard_booking_count/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  getContainerCountBasedOnLocation(q): Observable<any> {
    const params = new HttpParams()
      .set('q', q);
    const requestUrl = this.baseUrl + '/dashboard/intransit_container';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  getSeaRouteTemp(): Observable<any> {
    const requestUrl = this.baseUrl + '/dashboard/location_map_route';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }


  getRecentRateSearch(): Observable<any> {
    const requestUrl = this.baseUrl + '/recent_rates_search/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  // getRateSearchServices(obj): Observable<any> {
  //   const params = new HttpParams()
  //     .set('limit', obj.limit)
  //     .set('type', obj.type)
  //     .set('q', obj.q)
  //   const requestUrl = this.crmRateSearch + '/service/' + obj["type"] + '/';
  //   return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  // }


  // Get User management user list
  getUserManagementList(): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/users/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }


  addUser(body): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/users/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }




  getRateSearchInit(): Observable<any> {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/rate_search_init/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  getAdditionalService(body): Observable<any> {
    const requestUrl = this.baseUrl + '/additional_service/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getRateSearchRoute(body): Observable<any> {
    const requestUrl = this.baseUrl + '/rate_search_route/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }


  searchCreateBookingServices(obj): Observable<any> {
    const params = new HttpParams()
      .set('q', obj.q)
      .set('type', obj.type)
      .set('limit', !!obj.limit ? obj.limit : 0)
    const requestUrl = this.appBaseUrl + '/create_booking_search/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getBookingInitInfo(): Observable<any> {
    const requestUrl = this.baseUrl + '/shipment/create_init';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  getPastBooking(obj): Observable<any> {
    const params = new HttpParams()
      .set('request_type', obj.request_type)
    const requestUrl = this.appBaseUrl + '/past_bookings/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  getTodoList(body: any): Observable<any> {
    const params = new HttpParams()
      .set('limit', body.limit ? body.limit : 10)
      .set('page', body.page ? body.page : 0)
      .set('filter', !!body.filter ? body.filter : 'all')
      .set('sort_type', body.sort_type)
    const requestUrl = this.baseUrl + '/todo/get/' + body.type;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getTodoInfoByTypeAndId(body: any): Observable<any> {
    const params = new HttpParams()
      .set('shipment_id', !!body.shipment_id ? body.shipment_id : '')
      .set('type', body.type)
    const requestUrl = this.baseUrl + '/todo/get/' + body.type + '/' + body.shipment_id;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  getTodoCount(type: string): Observable<any> {
    const params = new HttpParams()
      .set('type', type)
    const requestUrl = this.baseUrl + '/todo/count/' + type;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }
  updateSIVGM(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/todo/update/' + body.type + '/' + body.shipment_id;
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getRateSearch(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/rate_search/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getRateSearchFilter(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/rate_search_filter/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  storeBookingInfo(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/store_booking_info/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }
  getStoreBookingInfoByID(id): Observable<any> {
    const params = new HttpParams();
    const requestUrl = this.baseUrl + '/store_booking_info/' + id;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getQuotationOption(body: any): Observable<any> {
    const params = new HttpParams()
      .set('q', !!body.q ? body.q : '')
      .set('column_name', body.column_name);
    const requestUrl = this.baseUrl + '/quotation/option/' + body["column_name"];
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getQuotation(body: any): Observable<any> {
    const params = new HttpParams()
      .set('limit', body.limit ? body.limit : 10)
      .set('page', body.page ? body.page : 0)
      .set('filter_type', body.filter_type)
      .set('id', !!body.id ? body.id : '')
      .set('origin', !!body.origin ? body.origin : '')
      .set('destination', !!body.destination ? body.destination : '')
      .set('status', !!body.status ? body.status : '')
      .set('ref_no', !!body.ref_no ? body.ref_no : '')
      .set('sort_type', body.sort_type);
    const requestUrl = this.baseUrl + '/quotation/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getQuotationInfoByID(id: string): Observable<any> {
    const params = new HttpParams()
      .set('id', id);
    const requestUrl = this.baseUrl + '/quotation/' + id;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getQuotationCount(): Observable<any> {
    const params = new HttpParams();
    const requestUrl = this.baseUrl + '/quotation_count';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  requestNegotiation(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/quotation/negotiate/' + body["quote_id"];
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getPortSearch(obj: { limit: string | number | boolean; q: string | number | boolean; }): Observable<any> {
    const params = new HttpParams()
      .set('limit', !!obj.limit ? obj.limit : 10)
      .set('q', !!obj.q ? obj.q : '')
    const requestUrl = this.baseUrl + '/port_search/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  createRateRequest(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/rate_request/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getRateRequest(body: any): Observable<any> {
    const params = new HttpParams()
      .set('limit', body.limit ? body.limit : 10)
      .set('page', body.page ? body.page : 0)
      .set('filter_type', body.filter_type)
      .set('id', !!body.id ? body.id : '')
      .set('sort_type', body.sort_type);
    const requestUrl = this.baseUrl + '/rate_request/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }
  getRateRequestCount(): Observable<any> {
    const params = new HttpParams();
    const requestUrl = this.baseUrl + '/rate_request/count';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  getInvoiceStatement(obj): Observable<any> {
    const requestUrl = this.baseUrl + '/finance/export/invoice_statement';
    return this.http.put<any>(requestUrl, obj).pipe(map(this.extractData));
  }

  fileUpload(body): Observable<any> {
    const requestUrl = this.baseUrl + '/file/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  deleteFile(filename): Observable<any> {
    const requestUrl = this.baseUrl + '/file/' + filename;
    return this.http.delete<any>(requestUrl).pipe(map(this.extractData));
  }

  deleteItem(tableName, rowId): Observable<any> {
    const requestUrl = this.baseUrl + '/delete/' + tableName + "/" + rowId;
    return this.http.delete<any>(requestUrl).pipe(map(this.extractData));
  }



  // getInvoiceById(id): Observable<any> {
  //   const params = new HttpParams()
  //   .set('invoice_ids',id)
  //   const requestUrl = this.baseUrl + '/my-finance/invoice_info/';
  //   return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  // }

  getInvoiceTodownload(obj): Observable<any> {
    const params = new HttpParams()
      .set('type', obj.type)
    const requestUrl = this.baseUrl + '/finance/invoice/' + obj.id;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  cancelBooking(body): Observable<any> {
    const requestUrl = this.baseUrl + '/shipment/cancel_request/' + body.id;
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  updateInvoicePayment(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/finance/make_payment/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }
  getShipmentDocs(id): Observable<any> {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/shipment/documents/' + id + '/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }
  getShipmentDocsTypeList(id): Observable<any> {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/shipment/documents_type/' + id + '/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  uploadShipmentDocument(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/shipment/documents/' + body.id + '/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }


  createTicket(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/ticket/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }
  cancelTicket(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/ticket/cancel/' + body.id;
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }
  getTicketCount(): Observable<any> {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/ticket/count';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }
  getTicketList(obj: any): Observable<any> {
    const params = new HttpParams()
      .set('limit', obj.limit)
      .set('page', obj.page)
      .set('static_filter', obj.filter_type)
      .set('sort', obj.sort_type)
      .set('id', !!obj.id ? obj.id : '')
    const requestUrl = this.baseUrl + '/ticket/get';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getBookingInfoForAmendByID(type, id: any): Observable<any> {
    const params = new HttpParams();
    const requestUrl = this.baseUrl + '/amend/' + type + '/' + id;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  updateBookingAmend(obj: any): Observable<any> {
    const requestUrl = this.baseUrl + '/amend/submit';
    return this.http.post<any>(requestUrl, obj).pipe(map(this.extractData));
  }

  getCommonSearch(body): Observable<any> {
    const requestUrl = this.baseUrl + '/common_search/' + body.type;
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }
  getCommonOption(body): Observable<any> {
    const requestUrl = this.baseUrl + '/common_search/' + body.type;
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  // delivery zip codes from tracking_server: flow_pod.postal_codes, then tracking_db.postal_geo_master
  searchZipcodes(q: string): Observable<any> {
    return this.http.post<any>(environment.airliftnet + 'tracking/customer_service/zipcode_search/', { q: q, limit: 20 });
  }

  getQueryParaInfo(body): Observable<any> {
    const requestUrl = this.baseUrl + '/query_info';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }



  getKycDetail(tabName): Observable<any> {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/kyc/get/' + tabName;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getCheckKyc() {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/kyc/check_kyc';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  updateKycDetail(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/kyc/update';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  createKycDetail(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/kyc/submit';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getTokenAccess(body): Observable<any> {
    const requestUrl = this.baseUrl + '/check_token';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getNotification(obj) {
    const params = new HttpParams()
      .set('limit', obj.limit)
      .set('page', obj.page)
      .set('filter_type', !!obj.filter_type ? obj.filter_type : 'all')
    const requestUrl = this.baseUrl + '/notification/get/' + obj.filter_type + '/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getNotificationCount() {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/notification/count';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


  markAsRead(body): Observable<any> {
    const requestUrl = this.baseUrl + '/notification/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getNotificationPreference(type) {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/notification/preference/' + type + '/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  updateNotificationPreference(body) {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/notification/preference/' + body.action_type + '/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getProfile(id) {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/admin/profile/' + id + '/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  updateProfile(id: any, body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/profile/' + id + '/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  changePassword(id: any, body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/change_password/' + id + '/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  // FCM token update to respect user id
  fcmTokenUpdate(body): Observable<any> {
    const requestUrl = this.appBaseUrl + '/fcm_token/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getBankDetails(): Observable<any> {
    const requestUrl = this.baseUrl + '/finance/bank_info/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }




  getVesselSchedule(obj: any): Observable<any> {
    const params = new HttpParams()
      .set('origin', obj.origin)
      .set('destination', obj.destination)
      .set('from', obj.from)
      .set('to', obj.to)
      .set('filter_type', obj.filter_type)
      .set('routing', !!obj.routing ? obj.routing : '')
      .set('sort_by', obj.sort_by)
      .set('nf', !!obj.nf ? obj.nf : 0)
      .set('nt', !!obj.nt ? obj.nt : 0)
      .set('liner', !!obj.liners ? obj.liners : '')
      .set('search_from', !!obj.search_from ? obj.search_from : 'schedule')
      .set('no_ofstop', !!obj.no_ofstop ? obj.no_ofstop : '0')
      .set('vs_type', !!obj.vs_type ? obj.vs_type : 'transit')

    const requestUrl = this.baseUrl + '/tools/vessel_schedule/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getTodoActivity(obj): Observable<any> {
    const requestUrl = this.baseUrl + '/todo/activity/' + obj?.shipment_id + "/" + obj?.container_id;
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  getTodoBookingAmend(amend_id: any): Observable<any> {
    const requestUrl = this.baseUrl + '/amend/info/' + amend_id + '/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  confirmBookingAmend(body): Observable<any> {
    const requestUrl = this.baseUrl + '/amend/validate/' + body.id + '/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  updateBlVerification(body): Observable<any> {
    const requestUrl = this.baseUrl + '/todo/update/' + body.type + '/' + body.id;
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }


  getRateSearchHint(body): Observable<any> {
    const requestUrl = this.baseUrl + '/rate_hint/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }


  checkMailIdUnqiue(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/checker/mail';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getAppInfo(domain): Observable<any> {
    const params = new HttpParams();
    const requestUrl = this.baseUrl + '/appInfo/' + domain;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }
  filterValueSearch(obj): Observable<any> {
    const requestUrl = this.baseUrl + '/filter_search/';
    return this.http.post<any>(requestUrl, obj).pipe(map(this.extractData));
  }



  // Destination side rework later
  destinationContainerData(body): Observable<any> {
    const requestUrl = 'https://api.airliftnet.com/tracking/customer_service/containerDetails/' + body;
    return this.http.get(requestUrl);
  }
  getFiterTableValues(shipId) {
    return this.http.get('https://api.airliftnet.com/tracking/customer_service/vesselDetails/' + shipId);
  }
  destinationDoc(shipId, tags?: any): Observable<any> {
    return this.http.get('https://api.airliftnet.com/tracking/customer_service/docsDetails/' + shipId + (tags ? '?tags=' + tags : ""));
  }
  createValues(value, tableName) {
    const payload: any = {
      "table_name": tableName,
      "values": [value]
    };
    return this.http.post('https://api.airliftnet.com/tracking/commonInsert/', payload);
  }
  createFile(value) {
    return this.http.post('https://api.airliftnet.com/trackingfiles/portal/insert', value);
  }
  mailFileSend(payload) {
    return this.http.post('https://api.airliftnet.com/tracking/mail/sendMail/', payload);
  }
  getValues(value) {
    return this.http.post('https://api.airliftnet.com/tracking/customer_service/commonGet/', value);
  }
  getFiterMainTableValues(value) {
    return this.http.post('https://api.airliftnet.com/tracking/commonMainTableData/', value);
  }

  getMile(body: any) {
    return this.http.post('https://api.airliftnet.com/tracking/customer_service/get_miles/', body);
  }

  getRate(body: any) {
    return this.http.post('https://api.airliftnet.com/tracking/customer_service/rate_api/', body);
  }

  getFallbackPort(body: any): Observable<any> {
    return this.http.post<any>('https://api.airliftnet.com/tracking/customer_service/find_fallback_port/', body);
  }

  // destination code end
}
